
import Vue from "vue";
import UserLogoImageComponent from "./UserLogoImage.vue";

export default Vue.extend({
  name: "UserInfo",
  components: {
    UserLogoImage: UserLogoImageComponent,
  },
  props: {
    // Busca e mapeamento ficam no controller da tela (UserDetailController)
    // — este componente é só apresentação. `user` ainda não tem um
    // viewmodel próprio, é o dado bruto retornado pelo UserService.
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      addressColumns: [
        {
          name: "Nome do local",
          sortName: null,
          order: null,
        },
        {
          name: "Endereço",
          sortName: null,
          order: null,
        },
        {
          name: "Complemento",
          sortName: null,
          order: null,
        },
      ],
    };
  },
});
